<template>
  <el-dialog
    append-to-body
    width="600px"
    :title="`部分回款(${info ? info.company_name : ''})`"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      element-loading-text="加载中…"
      ref="elFormDom"
      :model="form"
      :rules="rules"
      label-width="130px"
      label-position="right"
      :size="subUnitSize"
    >
      <el-form-item label="回款类型：" prop="radio">
        <el-radio-group v-model="form.radio">
          <el-radio :label="1">部分回款</el-radio>
          <el-radio :label="2">全额回款</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="form.radio == 1">
        <el-form-item label="已回金额："
          >￥{{ info.received_amount }}</el-form-item
        >
        <el-form-item prop="amount" label="本次回款金额：">
          <el-input v-model="form.amount" placeholder="请输入" clearable>
            <template #append>元</template>
          </el-input>
        </el-form-item>
      </template>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="loading"
          :disabled="loading"
          @click="confirm"
          >确定</el-button
        >
        <el-button @click="toggle(false)">取消</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      form: {
        radio: "",
        amount: "",
      },
      info: {},
      rules: {
        radio: [{ required: true, message: "必填", trigger: "change" }],
        amount: [{ required: true, message: "必填", trigger: "change" }],
      },
    };
  },
  methods: {
    // 获取组织详情
    getDetail(row) {
      this.info = row;
    },
    reset(done) {
      this.form = { radio: "", amount: "" };
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          if (this.form.radio == 1) {
            let params = {
              id: this.info.id,
              amount: this.form.amount,
            };
            this.$http
              .post("/admin/finance/receivedAmount", params)
              .then((res) => {
                if (res.code === 1) {
                  this.$message.success("操作成功！");
                  this.$emit("refresh");
                  this.toggle(false);
                }
              });
          } else {
            let str = `${this.info.company_name}${this.info.year}-${this.info.month}工资款项确认全额回款吗？`;
            this.$confirm(str, "全额回款", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              center: true,
              type: "warning",
            }).then(() => {
              this.allReceivedAmount(this.info);
            });
          }
        } else {
          return false;
        }
      });
    },
    allReceivedAmount(row) {
      let params = {
        id: row.id,
      };
      this.$http.post("/admin/finance/received", params).then((res) => {
        if (res.code === 1) {
          this.$message.success("操作成功！");
          this.$emit("refresh");
          this.toggle(false);
        }
      });
    },
  },
};
</script>
